import { createApi } from '@reduxjs/toolkit/query/react';

import {
  MigrationEndpoints as Endpoints,
  type CreateMigrationYClientsRequest,
  type CreateMigrationYClientsResponse,
  type GetMigrationYClientsRequest,
  type GetMigrationYClientsResponse,
  type GetMigrationsYClientsRequest,
  type GetMigrationsYClientsResponse,
  type UpdateStatusMigrationYClientsRequest,
  type UpdateStatusMigrationYClientsResponse,
} from '@app/api/Migration/types';
import { createApiBaseQuery, Methods } from '@app/api/shared';
import { MIGRATION } from '@app/constants';

const MIGRATIONS_TAG = 'Migrations';

export const migrationApi = createApi({
  reducerPath: 'migrationApi',
  baseQuery: createApiBaseQuery(MIGRATION),
  tagTypes: [MIGRATIONS_TAG],
  endpoints: ({ mutation, query }) => ({
    [Endpoints.GetMigrationsYClients]: query<
      GetMigrationsYClientsResponse,
      GetMigrationsYClientsRequest
    >({
      query: (params) => ({
        url: Endpoints.GetMigrationsYClients,
        method: Methods.GET,
        params,
      }),
      providesTags: [MIGRATIONS_TAG],
    }),
    [Endpoints.GetMigrationYClients]: query<
      GetMigrationYClientsResponse,
      GetMigrationYClientsRequest
    >({
      query: (params) => ({
        url: Endpoints.GetMigrationYClients,
        method: Methods.GET,
        params,
      }),
      providesTags: [MIGRATIONS_TAG],
    }),
    [Endpoints.CreateMigrationYClients]: mutation<
      CreateMigrationYClientsResponse,
      CreateMigrationYClientsRequest
    >({
      query: ({ data, ...params }) => ({
        url: Endpoints.CreateMigrationYClients,
        method: Methods.POST,
        params,
        data,
      }),
      invalidatesTags: [MIGRATIONS_TAG],
    }),
    [Endpoints.UpdateStatusMigrationYClients]: mutation<
      UpdateStatusMigrationYClientsResponse,
      UpdateStatusMigrationYClientsRequest
    >({
      query: (params) => ({
        url: Endpoints.UpdateStatusMigrationYClients,
        method: Methods.POST,
        params,
      }),
      invalidatesTags: [MIGRATIONS_TAG],
    }),
  }),
});

export const {
  useGetMigrationsYClientsQuery,
  useLazyGetMigrationsYClientsQuery,
  useGetMigrationYClientsQuery,
  useLazyGetMigrationYClientsQuery,
  useCreateMigrationYClientsMutation,
  useUpdateStatusMigrationYClientsMutation,
} = migrationApi;
